import { IonIcon } from '@ionic/react'
import { warning } from 'ionicons/icons'
import { ReactNode } from 'react'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { Title, Wrapper } from './styled'

type Props = {
  message?: string
  fullScreen?: boolean
  buttonNode?: ReactNode
}

export function NotFound({
  message = 'Страница не найдена',
  fullScreen = true,
  buttonNode,
}: Props) {
  return (
    <Wrapper $fullScreen={fullScreen}>
      <IonIcon
        icon={warning}
        style={{
          fill: myPalette.coral.main,
          width: '70px',
          height: '70px',
          marginBottom: '12px',
        }}
      />

      <Title>{message}</Title>

      {buttonNode || (
        <Button to='/' variant='textLink'>
          На главную
        </Button>
      )}
    </Wrapper>
  )
}
